import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const SETUP_PATH = "/profil-setup";

// Routes that should remain accessible even if profile is incomplete
const ALLOWED_PATHS = new Set<string>([
  SETUP_PATH,
  "/logga-in",
  "/registrera",
  "/villkor",
  "/integritetspolicy",
]);

export function ProfileCompletionGate() {
  const { user, profile, loading, isProfileComplete, hasRole, rolesLoaded } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return;
    // Wait until profile and roles are loaded to decide
    if (!profile) return;
    if (!rolesLoaded) return;
    // Don't trap admins
    if (hasRole("admin")) return;

    const path = location.pathname;
    if (isProfileComplete) {
      if (path === SETUP_PATH) {
        navigate("/", { replace: true });
      }
      return;
    }
    // Profile incomplete
    if (!ALLOWED_PATHS.has(path)) {
      navigate(SETUP_PATH, { replace: true, state: { from: path } });
    }
  }, [user, profile, loading, rolesLoaded, isProfileComplete, hasRole, location.pathname, navigate]);

  return null;
}
